var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCurriculumTopicScripting = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 60 60",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 30,
    fill: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#6A621C",
    d: "M22.48 38.127a7.7 7.7 0 0 1-1.6-.152q-.697-.153-.697-.559 0-.09.063-.406a3.7 3.7 0 0 1 .165-.584q.114-.267.28-.267.025 0 .279.051.33.075.571.127.255.038.571.038 1.677 0 2.412-.66.75-.66.75-2.12V22.65q0-.507.9-.507h.178q.915 0 .915.507v10.715q0 2.247-1.156 3.504-1.142 1.257-3.63 1.257m11.675 0q-1.245 0-2.323-.267-1.065-.279-1.714-.66-.635-.394-.635-.71 0-.18.14-.47.153-.293.343-.521t.304-.229q.102 0 .445.204.787.406 1.561.673.775.266 1.88.266.863 0 1.535-.33.673-.33 1.041-.927a2.6 2.6 0 0 0 .381-1.396q0-.838-.457-1.384a3.15 3.15 0 0 0-1.091-.876q-.636-.33-1.854-.812-1.32-.508-2.095-.94-.762-.445-1.307-1.282-.534-.839-.534-2.222 0-1.206.623-2.158.621-.965 1.764-1.498 1.143-.534 2.628-.533.673 0 1.536.19.864.178 1.473.495.622.318.622.699 0 .165-.14.456a2.5 2.5 0 0 1-.304.508q-.178.23-.28.229-.114 0-.457-.19a7 7 0 0 0-1.13-.483q-.558-.19-1.358-.19-1.308 0-2.12.672-.8.673-.8 1.88 0 .723.355 1.193.356.47.902.749.546.28 1.523.647.064.013.292.102 1.346.52 2.197 1.015.863.482 1.46 1.397.609.914.609 2.336 0 1.332-.622 2.323-.609.99-1.752 1.523-1.13.52-2.64.521"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCurriculumTopicScripting);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/curriculum-topic-scripting.e6dab470c3e1a051b27935b67e93c901.svg";